export enum AccountType {
  Jary = 0,
  PasAndaz = 1,
  QarzOlHasaneh = 2,
  Sepordehshort = 3,
  SepordehLong = 6,
}
